<div class="duration-custom-filter-input">
  <div class="time-fields-input-set">
    <glxy-form-field
      [bottomSpacing]="'none'"
      class="time-input"
      [suffixText]="'ACTIVITY.CUSTOM_FILTER.DURATION.HOURS' | translate"
    >
      <input
        [placeholder]="'TABLE_FILTERS.SELECT_EXPRESSION_PLACEHOLDER' | translate"
        type="number"
        matInput
        [formControl]="formGroup.controls['hour']"
        data-testid="filter-custom-duration-input-hour"
      />
    </glxy-form-field>

    <glxy-form-field
      [bottomSpacing]="'none'"
      class="time-input"
      [suffixText]="'ACTIVITY.CUSTOM_FILTER.DURATION.MINUTES' | translate"
    >
      <input
        [placeholder]="'TABLE_FILTERS.SELECT_EXPRESSION_PLACEHOLDER' | translate"
        type="number"
        matInput
        [formControl]="formGroup.controls['minute']"
        data-testid="filter-custom-duration-input-minute"
      />
    </glxy-form-field>

    <glxy-form-field
      [bottomSpacing]="'none'"
      class="time-input"
      [suffixText]="'ACTIVITY.CUSTOM_FILTER.DURATION.SECONDS' | translate"
    >
      <input
        [placeholder]="'TABLE_FILTERS.SELECT_EXPRESSION_PLACEHOLDER' | translate"
        type="number"
        matInput
        [formControl]="formGroup.controls['second']"
        data-testid="filter-custom-duration-input-second"
      />
    </glxy-form-field>
  </div>
  @if ((selectionType$$ | async) === 'range') {
    <span class="range-splitter">–</span>
    <div class="time-fields-input-set">
      <glxy-form-field
        [bottomSpacing]="'none'"
        class="time-input"
        [suffixText]="'ACTIVITY.CUSTOM_FILTER.DURATION.HOURS' | translate"
      >
        <input
          [placeholder]="'TABLE_FILTERS.SELECT_EXPRESSION_PLACEHOLDER' | translate"
          type="number"
          matInput
          [formControl]="formGroupEnd.controls['hour']"
          data-testid="filter-custom-duration-input-hour"
        />
      </glxy-form-field>

      <glxy-form-field
        [bottomSpacing]="'none'"
        class="time-input"
        [suffixText]="'ACTIVITY.CUSTOM_FILTER.DURATION.MINUTES' | translate"
      >
        <input
          [placeholder]="'TABLE_FILTERS.SELECT_EXPRESSION_PLACEHOLDER' | translate"
          type="number"
          matInput
          [formControl]="formGroupEnd.controls['minute']"
          data-testid="filter-custom-duration-input-minute"
        />
      </glxy-form-field>

      <glxy-form-field
        [bottomSpacing]="'none'"
        class="time-input"
        [suffixText]="'ACTIVITY.CUSTOM_FILTER.DURATION.SECONDS' | translate"
      >
        <input
          [placeholder]="'TABLE_FILTERS.SELECT_EXPRESSION_PLACEHOLDER' | translate"
          type="number"
          matInput
          [formControl]="formGroupEnd.controls['second']"
          data-testid="filter-custom-duration-input-second"
        />
      </glxy-form-field>
    </div>
  }
</div>
